import AppInterface from "../components/interfaces/AppInterface";

const AppNavigator = (props) => {
  return (
    <AppInterface />
  );
}

export default AppNavigator;
